import PropTypes from 'prop-types';
import React from 'react';
import { LinkButton } from '@ami/react/core';

const Row = ({ dealerUser, onOpenEdit }) => {
  const { userId, fullName, email, dealerGroups, isRetired, isRegistered } =
    dealerUser;
  return (
    <li className="row" key={1}>
      <div className="col-md-4 col-6">
        <div>
          {isRetired && <span>{fullName}</span>}
          {!isRetired && (
            <LinkButton
              id={userId}
              label={fullName}
              onClick={onOpenEdit.bind(userId)}
            />
          )}
        </div>
        <div>{email}</div>
      </div>
      <div className="col-md-6 col-6 text-center">
        <ul>
          {dealerGroups.map((group, index) => (
            <li key={index} className="text-start dealer-group-list-item">
              <div>
                <strong>Dealer Group:</strong> {group.dealerGroupName}
              </div>
              <div>
                <strong>Branch:</strong> {group.defaultDealerBranchName}
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div className="col-md-2 text-center">
        <strong>Is Registered:</strong> {isRegistered ? 'Yes' : 'No'}
      </div>
    </li>
  );
};

Row.propTypes = {
  dealerUser: PropTypes.object.isRequired,
  onOpenEdit: PropTypes.func.isRequired,
};

export default Row;
